<div class="search-container">
    <div class="store-stock-search">
        <div class="search-wrapper">
            <app-input-basic
                [control]="searchInput"
                [label]="'stores.placeholders.searchStore' | translateSafe"
                [placeholder]="'stores.placeholders.searchStore' | translateSafe"
                [autoFocus]="true"
                autocomplete="off"
                iconName="search"
            ></app-input-basic>
        </div>

        <div class="location-button-wrapper">
            <button
                class="kk-btn kk-btn_svg kk-btn_secondary location-button"
                [ngClass]="{ 'location-active': activeGeo }"
                (click)="activeGeo ? removeActiveGeo() : getGeoLocation()"
                [disabled]="currentPositionError"
            >
                <app-svg-icon iconName="close to me"></app-svg-icon>
                <span>{{ 'stores.buttons.closeToMe' | translateSafe }}</span>
            </button>
            <div class="tooltip-wrapper" *ngIf="currentPositionError as geoError">
                <app-tooltip>
                    <span class="tooltip-text">
                        {{
                            geoError.code === LocationCodeError.PermissionDenied
                                ? ('stores.labels.geoLocationDenied' | translateSafe)
                                : ('stores.labels.positionUnavailable' | translateSafe)
                        }}
                    </span>
                </app-tooltip>
            </div>
        </div>
    </div>
    <div class="only-stores-with-stock" *ngIf="type !== 'select'">
        <app-checkbox [control]="checkbox">
            {{ 'stock.checkbox.onlyStoresWithStock' | translateSafe }}
        </app-checkbox>
    </div>
</div>
<div class="store-stock-header">
    <h3
        class="display-5 store-stock-counter"
        *ngIf="type !== 'select' && (productDetailService.productDetail$ | async) as product"
    >
        {{
            'stock.headings.stockStatus'
                | translateSafe
                | formatString
                : {
                    storesWithStock: (
                        product.storeStocks
                            | storeMatches: (storesService.stores$ | async)
                            | storesWithStock
                    ).toString()
                }
        }}
    </h3>

    @if (type === 'reserve') {
        <button (click)="setStore()" class="kk-link kk-link_underline cancel-button">
            {{ 'general.action.cancel' | translateSafe }}
        </button>
    }
</div>

@defer (on viewport) {
    @if (storesService.stores$ | async; as stores) {
        @if ((stores | filterStoresByFlag: 'hideStoreStocks':false)?.length) {
            <ul class="store-list">
                @for (store of stores | sortFavoriteStore: (storesService.favoriteStore$ | async)?.storeId; track store?.storeId) {

                    <!-- Because we do not know about a specific product on PLP, we render a simple version of store-list-item -->
                    @if (type === 'select') {
                        <li
                            class="store-list-item"
                            [ngClass]="{
                        'store-selected': store.storeId === (storesService.favoriteStore$ | async)?.storeId
                    }"
                        >
                            <app-store-stock-list-item
                                [store]="store"
                                [type]="type"
                                (handleClick)="setStore(store)"
                                [isFavorite]="store.storeId === (storesService.favoriteStore$ | async)?.storeId"
                            >
                            </app-store-stock-list-item>
                        </li>
                    } @else {

                        @if (productDetailService.productDetail$ | async; as product) {
                            <li
                                class="store-list-item"
                                *ngIf="checkbox.value ? (product.storeStocks | storeStock: store) > 0 : true"
                            >
                                <app-store-stock-list-item
                                    [store]="store"
                                    [product]="product"
                                    [type]="type"
                                    (handleClick)="setStore(store)"
                                    [isFavorite]="store.storeId === (storesService.favoriteStore$ | async)?.storeId"
                                >
                                </app-store-stock-list-item>
                            </li>
                        }

                    }
                }
            </ul>
        } @else {
            <ng-container [ngTemplateOutlet]="emptyList"></ng-container>
        }
    }
} @placeholder {
    <app-loading-dots></app-loading-dots>
}

<ng-template #emptyList>
    <p class="no-stores" aria-live="polite">{{ 'stores.labels.noResults' | translateSafe }}</p>
</ng-template>
<ng-container
    *ngIf="
        checkbox.value &&
        !(
            (productDetailService.productDetail$ | async)?.storeStocks
            | storeMatches: (storesService.stores$ | async)
            | storesWithStock
        )
    "
>
    {{ 'stock.noStockInStores' | translateSafe }}
</ng-container>
